import React, { useEffect, useRef } from 'react';
import Slider from 'react-slick';

export default function AccessibleSlider({ settings, children }) {
  const sliderRef = useRef(null);

  // Programmatically prevent tabbing / interaction by forcing tabindex = -1
  // on all children elements
  useEffect(() => {
    [...sliderRef.current.querySelectorAll('*')].forEach((el) =>
      el.setAttribute('tabindex', '-1')
    );
  }, []);

  return (
    <div className="slider">
      <div aria-hidden ref={sliderRef}>
        <Slider {...settings}>{children}</Slider>
      </div>
      <div className="is-only-for-screen-readers">{children}</div>
    </div>
  );
}
